import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timeout = window.setTimeout(() => Turbo.visit(this.urlValue), 650)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }
}
